/**
 * PillAvatar — round tinted-pill with semantic icon.
 * Used in transaction rows, cashier breakdowns, team lists.
 *
 * Usage:
 *   <PillAvatar icon={ShoppingCart} tone="success" />
 *   <PillAvatar icon={User} tone="neutral" size="lg" />
 */

const TONES = {
  success: { bg: '#DCFCE7', color: '#16A34A' },
  warning: { bg: '#FEF3C7', color: '#D97706' },
  danger:  { bg: '#FEE2E2', color: '#DC2626' },
  info:    { bg: '#DBEAFE', color: '#2563EB' },
  neutral: { bg: '#F1F5F9', color: '#64748B' },
  brand:   { bg: '#DCFCE7', color: '#1A4D2E' },
};

const SIZES = {
  sm: { container: 'w-6 h-6', icon: 11 },
  md: { container: 'w-8 h-8', icon: 14 },
  lg: { container: 'w-10 h-10', icon: 16 },
};

export function PillAvatar({ icon: Icon, tone = 'neutral', size = 'md', className = '' }) {
  const t = TONES[tone] || TONES.neutral;
  const s = SIZES[size] || SIZES.md;

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full flex-shrink-0 ${s.container} ${className}`}
      style={{ backgroundColor: t.bg }}
    >
      {Icon && <Icon size={s.icon} style={{ color: t.color }} strokeWidth={1.75} />}
    </span>
  );
}
